import { motion } from 'framer-motion';
import { Server, Boxes, BrainCircuit, Shield } from 'lucide-react';
import '../styles/sections.css';
import './Architecture.css';

const layers = [
  {
    icon: <Server size={22} />,
    title: 'Hermes Agent API',
    desc: 'Centralized agent loop, deterministic pipeline execution, native MCP integration.',
  },
  {
    icon: <Boxes size={22} />,
    title: 'Keraunos MCP Server',
    desc: '64 production tools across code analysis, security, testing, docs, and deployment.',
  },
  {
    icon: <BrainCircuit size={22} />,
    title: 'Ollama Secure Model Servers',
    desc: 'Local custom fine-tuned or Ollama Cloud SOTA AI models.',
  },
  {
    icon: <Shield size={22} />,
    title: 'Private Network',
    desc: 'Code-enforced gates isolate memory, context, and credentials from external exposure.',
  },
];

export default function Architecture() {
  return (
    <section id="architecture" className="section sectionAlt">
      <div className="container">
        <div className="sectionHeader">
          <span className="sectionLabel">Architecture</span>
          <h2 className="sectionTitle">Your data. Secure infrastructure. Your models.</h2>
          <p className="sectionSubtitle">
            Deterministic agents run behind code-enforced quality gates. Every action,
            memory item, and credential is scoped to secure infrastructure you control.
          </p>
        </div>

        <div className="archGrid">
          {layers.map((layer, idx) => (
            <motion.div
              key={layer.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45, delay: idx * 0.08 }}
              className="archCard glassCard"
            >
              <div className="iconWrap">{layer.icon}</div>
              <h4>{layer.title}</h4>
              <p>{layer.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
